export const DESKTOP_ASIDE_HIDDEN_STORAGE_KEY = 'nosi_desktop_aside_hidden'

export const getStoredDesktopAsideHidden = (): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  try {
    return window.localStorage.getItem(DESKTOP_ASIDE_HIDDEN_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export const persistDesktopAsideHidden = (hidden: boolean): void => {
  if (typeof window === 'undefined') {
    return
  }

  try {
    window.localStorage.setItem(DESKTOP_ASIDE_HIDDEN_STORAGE_KEY, String(hidden))
  } catch {
    // The layout remains usable when storage is unavailable.
  }
}
